import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IDataResponseAuth,
	IReqlogout,
	IRequestAuth,
	IResponseLogout,
	IRequestLinkRecovery,
	IResponseLinkRecovery,
	IReqRegisterDevice,
	IResRegisterDevice
} from '@pacifico/interfaces/auth-api.interface';
import { Observable } from 'rxjs';
import { EndPointApiService } from '../endpoint-api.service';
import { IResponse } from '@pacifico/services/api/endpoint-api';

@Injectable({ providedIn: 'root' })
export class AuthService {
	constructor(private _httpClient: HttpClient, private _endPointApiService: EndPointApiService) {}

	auth(user: IRequestAuth): Observable<IDataResponseAuth> {
		return this._httpClient.post<IDataResponseAuth>(this._endPointApiService.AUTH.login, user);
	}

	logout(logout: IReqlogout): Observable<IResponseLogout> {
		return this._httpClient.post<IResponseLogout>(this._endPointApiService.AUTH.logout, logout);
	}

	linkRecovery(req: IRequestLinkRecovery): Observable<IResponse<IResponseLinkRecovery>> {
		return this._httpClient.post<IResponse<IResponseLinkRecovery>>(this._endPointApiService.AUTH.linkRecovery, req);
	}

	refresh(): Observable<string> {
		return this._httpClient.post<string>(this._endPointApiService.AUTH.refresh, {});
	}

	registerDevice(req: IReqRegisterDevice): Observable<IResponse<IResRegisterDevice>> {
		return this._httpClient.post<IResponse<IResRegisterDevice>>(this._endPointApiService.AUTH.registerDevice, req);
	}
}
